module.exports = __webpack_public_path__ + "images/emoji/rage2.0bcbb0b4a7a3a260573f.png";